<template>
  <div class="share-file-panel ma-0 p-1" >
    <v-card-title class="title">{{$tf('Share')}}</v-card-title>
    <v-card-text mb-2 style="padding: 0 !important;">
      <v-layout row wrap>
        <v-alert
          dismissible
          type="info"
          class="ma-0"
          :value="showSlowShareAlert"
          style="border: none !important;"
          >
          {{$tf('slowShareAlert', {
          type:
            file && file.type && file.type === 'directory'
            ? $tf('folder') : $tf('file')})}}
        </v-alert>
        <v-alert
          dismissible
          type="info"
          class="ma-0"
          :value="showSlowUnshareAlert"
          style="border: none !important;"
          >
          {{$tf('slowUnshareAlert', {
          type:
            file && file.type && file.type === 'directory'
            ? $tf('folder') : $tf('file')})}}
        </v-alert>
        <v-flex xs12>
          <v-menu
            :nudge-bottom="50"
            content-class="menu-xs-responsive"
            full-width
            :open-on-click="false"
            :value="openMenu"
            :max-height="400"
          >
            <v-container slot="activator" class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <VTextFieldExtended
                    ref="searchUser"
                    name="search-user"
                    autocomplete="off"
                    :loading="searchLoading"
                    :hint="currentlySharedWith"
                    @focus.native="openMenu = true"
                    @input.native="openMenu = true"
                    @mousedown.native="openMenu = true"
                    @focusout.native="openMenu = false"
                    class="pb-0"
                    v-model="searchInputValue"
                    :label="$tf('Search users, groups') + '...'"
                  />
                </v-flex>
              </v-layout>
            </v-container>

            <template v-if="searchInputValue.length">
              <v-list v-if="results.length > 0" two-line class="search-result py-0">
                <template v-for="(item, index) in results">
                  <v-divider
                    v-if="index > 0"
                    :key="item.actor_id+'-divider'"
                    :inset="!smallerThan('sm')"
                  />
                  <v-list-tile
                    avatar
                    href="#"
                    @mousedown.native.prevent="toggleItem(item)"
                    @keydown.native.enter="toggleItem(item)"
                    :key="item.actor_id"
                  >
                    <template v-if="item.shareType === 'guest'">
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.email" />
                        <v-list-tile-sub-title>{{$tf('WarningSharingWithGuest')}}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                    <template v-else>
                      <v-list-tile-avatar>
                        <provisional-avatar :item="item"></provisional-avatar>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <template>
                          <template>
                            <v-list-tile-title v-html="item.name" />
                          </template>
                          <v-list-tile-sub-title
                            v-if="item.additional_info"
                          >{{item.additional_info}}</v-list-tile-sub-title>
                        </template>
                      </v-list-tile-content>
                    </template>
                  </v-list-tile>
                </template>
              </v-list>

              <v-list v-else>
                <v-list-tile>
                  <v-list-tile-content>{{$tf('No results')}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </template>
          </v-menu>

          <v-container class="mt-3 mb-3 share-with-container" v-if="selected.length > 0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs3>
                    <label class="body-2">{{$tf('Share with')}}:</label>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6>
                    <v-layout row wrap align-start mt-1>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm4>
                        <span class="body-2">{{$tf('Permission to')}}:</span>
                      </v-flex>

                      <v-flex xs12 sm7 style="margin-top: -25px">
                        <v-select
                          :items="permissions"
                          :hide-details="true"
                          class="pl-3 pb-0 permission-select"
                          v-model="permission"
                        >
                          <template slot="selection" slot-scope="data">
                            <v-spacer></v-spacer>
                            <v-icon>{{data.item.icon}}</v-icon>
                            <v-spacer v-if="$vuetify.breakpoint.smAndUp" style="max-width: 6px"></v-spacer>
                            <v-list-tile-content
                              v-if="$vuetify.breakpoint.smAndUp"
                            >{{data.item.text}}</v-list-tile-content>
                          </template>
                          <template slot="item" slot-scope="data">
                            <v-list-tile-avatar>
                              <v-icon>{{data.item.icon}}</v-icon>
                            </v-list-tile-avatar>
                            <v-list-tile-content>{{data.item.text}}</v-list-tile-content>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 class="items mt-2">
                    <v-chip
                      close
                      v-for="item in selected"
                      :key="item.actor_id"
                      @input="toggleItem(item)"
                    >
                      <div v-if="item.shareType === 'guest'" class="name-chip">{{item.email}}</div>
                      <template v-else>
                        <provisional-avatar :item="item" font-size="20"></provisional-avatar>
                        <div v-if="item.name" class="name-chip">{{item.name}}</div>
                        <div v-else class="name-chip">{{item.email}}</div>
                      </template>
                    </v-chip>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="showMessage">
                <v-text-field
                  name="message"
                  multi-line
                  :label="$tf('Write a message')"
                  v-model="message"
                />
              </v-flex>
              <v-flex xs12>
                <div class="share-btn-wrapper">
                  <v-btn
                    class="mb-0 mr-0"
                    v-if="!showMessage"
                    flat
                    @click.native="showMessage = true"
                  >{{$tf('Add a message')}}</v-btn>
                  <v-btn
                    :disabled="shareLoading"
                    :loading="shareLoading"
                    color="primary"
                    class="share-btn mb-0 mr-0"
                    @click.native="share"
                  >{{$tf('Share')}}</v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-fade-transition mode="out-in">
          <v-flex xs12 key="sharedWith">
            <template v-if="sharedWithList.length > 0">
              <label>{{$tf('Shared with')}}</label>
              <v-list class="shared-with-list">
                <v-list-tile
                  v-for="(sharedWithItem, index) in sharedWithList"
                  :key="index"
                  avatar
                >
                  <template v-if="sharedWithItem._type === 'accounts'">
                    <v-list-tile-avatar>
                      <avatar :account="sharedWithItem" :size="smallerThan('sm') ? 28 : 42" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <template v-if="sharedWithItem.firstname || sharedWithItem.lastname">
                        <template v-if="sharedWithItem.firstname">
                          <v-list-tile-title v-html="sharedWithItem.firstname + ' ' + sharedWithItem.lastname" />
                        </template>
                        <template v-else>
                          <v-list-tile-title v-html="sharedWithItem.lastname" />
                        </template>
                        <v-list-tile-sub-title>{{sharedWithItem.username}}</v-list-tile-sub-title>
                      </template>
                      <template v-else>
                        <v-list-tile-title v-html="sharedWithItem.username" />
                      </template>
                    </v-list-tile-content>
                    <shared-with-actions
                      :permissions="permissions"
                      :item="sharedWithItem"
                      :disabled="isBlocked"
                      type="account"
                      :file-id="fileID"
                      @block="blockButton"
                      @alert="showUnshareAlert"
                    ></shared-with-actions>
                  </template>

                  <template v-if="sharedWithItem._type === 'groups'">
                    <v-list-tile-avatar>
                      <provisional-avatar :item="sharedWithItem"></provisional-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <template>
                        <v-list-tile-title v-html="sharedWithItem.name" />
                      </template>
                    </v-list-tile-content>
                    <shared-with-actions
                      :permissions="permissions"
                      :item="sharedWithItem"
                      :disabled="isBlocked"
                      type="group"
                      :file-id="fileID"
                      @block="blockButton"
                      @alert="showUnshareAlert"
                    ></shared-with-actions>
                  </template>

                  <template v-if="sharedWithItem._type === 'organizations'">
                    <v-list-tile-avatar>
                      <provisional-avatar :item="sharedWithItem"></provisional-avatar>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <template>
                        <v-list-tile-title v-html="sharedWithItem.name" />
                      </template>
                    </v-list-tile-content>
                    <shared-with-actions
                      :permissions="permissions"
                      :item="sharedWithItem"
                      :disabled="isBlocked"
                      type="organization"
                      :file-id="fileID"
                      @block="blockButton"
                      @alert="showUnshareAlert"
                    ></shared-with-actions>
                  </template>

                  <template v-if="sharedWithItem._type === 'guests'">
                    <v-list-tile-avatar>
                      <avatar :alt="sharedWithItem.email" :size="smallerThan('sm') ? 28 : 42" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="sharedWithItem.email" />
                      <v-list-tile-sub-title>{{$tf('Pending invitation')}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <shared-with-actions
                      :permissions="permissions"
                      :item="sharedWithItem"
                      :disabled="isBlocked"
                      type="guest"
                      :file-id="fileID"
                      @block="blockButton"
                      @alert="showUnshareAlert"
                    ></shared-with-actions>
                  </template>
                </v-list-tile>
              </v-list>
              <v-spacer></v-spacer>
              <v-btn
                v-if="file !== null && accountOwner.account_id === $store.state.session.account.account_id"
                :disabled="isBlocked"
                :loading="unshareLoading"
                :color="isUserSure ? 'error' : 'gray'"
                :flat="!isUserSure"
                @click="isUserSure ? stopSharingWithEverybody() : isUserSure = true"
                class="stop-sharing-w-everybody-btn mt-3 mb-2 mr-0"
              >
                <v-icon left>stop_screen_share</v-icon>
                <template v-if="isUserSure">{{$tf('ARE YOU SURE')}}</template>
                <template v-else>{{$tf('STOP SHARING')}}</template>
              </v-btn>
            </template>
            <template v-else>
              <template
                v-if="file !== null && accountOwner.account_id === $store.state.session.account.account_id"
              >{{$tf('This file isn\'t currently shared')}}</template>
              <template v-else>{{$tf('This file is only shared to you')}}</template>
            </template>
          </v-flex>
        </v-fade-transition>
        <v-container class="mt-5 px-0 checkbox-container">
          <v-checkbox
            v-model="subscribed"
            :label="$tf('EnableSubscription')"
            :disabled="!sharedWith.privateShared"
            @change="openSuscriptionDialog"
          />
          <p style="font-size: 0.95rem; margin: 0 2em">{{ $tf('SubscriptionDetails') }}</p>
        </v-container>
        <v-dialog v-model="showSuscriptionDialog" width="350px" permanent>
          <v-card>
            <v-card-title v-if="subscribed" class="headline">{{$tf('EnableSubscriptionShort')}}</v-card-title>
            <v-card-title v-else class="headline">{{$tf('DisableSuscription')}}</v-card-title>
            <v-card-text>
              <p v-if="subscribed">{{$tf("Are you sure you want to enable the notifications for this folder")}}</p>
              <p v-else>{{$tf("Are you sure you want to disable the notifications for this folder")}}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat="flat" @click.native="closeSuscriptionDialog">{{$tf('Cancel')}}</v-btn>
              <v-btn color="primary" dark @click.native="suscribe">{{$tf('Accept')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-card-text>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Validator } from 'vee-validate/dist/vee-validate'
import MainBus from '~/bus'
import Api from '~/store/idonia-api/api.js'
import ProvisionalAvatar from '~/components/common/ProvisionalAvatar.vue'
import SharedWithActions from '~/components/common/share/SharedWithActions.vue'
import VTextFieldExtended from '~/components/vuetify/VTextFieldExtended.vue'
import { useBusUtils } from '~/commons/busUtils'
import { debounce } from 'lodash'

const { BusHandlerManager } = useBusUtils()

function shuffleArray (pArray) {
  const array = pArray.slice()
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export default {
  name: 'share-private',
  components: { SharedWithActions, ProvisionalAvatar, VTextFieldExtended },
  props: {
    file: {
      type: Object,
      required: null
    },
    sharedWith: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      bhm: new BusHandlerManager(),
      searchLoading: false,
      searchInputValue: '',
      selected: [],
      results: [],
      shareLoading: false,
      unshareLoading: false,
      disabled: false,
      showSlowShareAlert: false,
      showSlowUnshareAlert: false,
      $validator: null,
      permission: 'read',
      permissions: [
        {
          text: this.$tf('Total control'),
          value: 'all',
          icon: 'verified_user'
        },
        { text: this.$tf('Modify'), value: 'edit', icon: 'mode_edit' },
        { text: this.$tf('ReadLabel'), value: 'read', icon: 'remove_red_eye' }
      ],
      showMessage: false,
      message: '',
      openMenu: false,
      hoveredOption: null,
      isUserSure: false,
      subscribed: false,
      showSuscriptionDialog: false
    }
  },
  created () {
    this.bhm.addHandler(MainBus, 'shareLoadedCompleted', id => {
      if (id === this.file.id_file) {
        this.shareCompleted()
      }
    })
    this.bhm.addHandler(MainBus, 'unshareLoadedCompleted', id => {
      if (id === this.file.id_file) {
        this.unshareCompleted()
      }
    })
    this.$validator = new Validator()
    this.$validator.attach({
      name: 'email',
      rules: 'required|email'
    })

    window.addEventListener('resize', () => {
      this.$forceUpdate()
    })
  },
  destroyed () {
    this.bhm.cleanAll()
  },
  methods: {
    itemType (item) {
      return item.actor_id.split('/')[0]
    },
    itemID (item) {
      return item.actor_id.split('/')[1]
    },
    searchUser (match) {
      return new Promise((resolve, reject) => {
        if (!match || match.trim() === '') {
          return
        }
        Api.getV2('account-contacts', { match })
          .then(response => {
            if (
              response &&
              response.body &&
              response.body.constructor === Array
            ) {
              resolve(response.body)
            }
            reject(response)
          })
          .catch(reject)
      })
    },
    stopSharingWithEverybody () {
      this.unshareLoading = true
      const unshareLoadingTimeout = setTimeout(() => {
        if (this.unshareLoading) {
          this.showSlowUnshareAlert = true
        }
      }, 2000)
      this.$store
        .dispatch('shareFile/deleteAll', this.file.id_file)
        .then(() => {
          clearTimeout(unshareLoadingTimeout)
        })
        .catch(response => {
          if (response.status !== undefined && (response.status === 502 || response.status === 0)) {
            this.$store.dispatch('feedback/addSnack', { text: 'Unsharing will take a few moments' })
          } else {
            this.$store.dispatch('feedback/addSnack', {
              text: 'Something went wrong'
            })
            this.isUserSure = false
            this.unshareLoading = false
            clearTimeout(unshareLoadingTimeout)
            setTimeout(() => {
              this.showSlowUnshareAlert = false
            }, 3000)
          }
        })
    },
    toggleItem (item) {
      this.searchInputValue = ''
      this.openMenu = false
      this.results = []
      const indexOfItem = this.selected.findIndex(selectedItem => {
        return selectedItem.shareType === 'guest'
          ? selectedItem.email === item.email
          : selectedItem.actor_id === item.actor_id
      })
      item.permission = this.permission
      if (indexOfItem === -1) {
        this.selected.push(item)
      } else {
        this.selected.splice(indexOfItem, 1)
      }
    },
    async share () {
      this.shareLoading = true
      const shareLoadingTimeout = setTimeout(() => {
        if (this.shareLoading) {
          this.showSlowShareAlert = true
        }
      }, 2000)
      this.$store
        .dispatch('shareFile/add', {
          id: this.fileID,
          params: {
            actors: this.selected.filter(item => item.actor_id).map(item => item.actor_id),
            guests: this.selected
              .filter(item => item.shareType === 'guest')
              .map(item => item.email),
            permission: this.permission,
            message: this.message
          }
        })
        .then(() => {
          clearTimeout(shareLoadingTimeout)
        })
        .catch(response => {
          if (response.status !== undefined && (response.status === 502 || response.status === 0)) {
            this.$store.dispatch('feedback/addSnack', { text: 'Sharing will take a few moments' })
          } else {
            this.$store.dispatch('feedback/addCatchSnack', response)
            this.shareLoading = false
            clearTimeout(shareLoadingTimeout)
            setTimeout(() => {
              this.showSlowShareAlert = false
            }, 3000)
          }
        })
    },
    handleKeydownList (event) {
      if (this.openMenu && this.$refs.resultsList !== undefined) {
        this.$refs.resultsList.$el.children[0].focus()
      }
    },
    blockButton (value) {
      this.disabled = value
    },
    showUnshareAlert (value) {
      this.showSlowUnshareAlert = value
    },
    shareCompleted () {
      this.$store.dispatch('feedback/addSnack', {
        text: 'Shared correctly'
      })
      this.selected = []
      this.results = []

      this.shareLoading = false
      setTimeout(() => {
        this.showSlowShareAlert = false
      }, 3000)

      this.disabled = false
    },
    unshareCompleted () {
      this.selected = []
      this.results = []
      this.$emit('set-shared-with', {
        accounts: [],
        groups: [],
        guests: [],
        public_url: this.sharedWith.public_url
      })

      this.isUserSure = false
      this.$store.dispatch('feedback/addSnack', {
        text: 'Stopped sharing'
      })
      // MainBus.$emit('doBackgroundReload')

      this.unshareLoading = false
      setTimeout(() => {
        this.showSlowUnshareAlert = false
      }, 3000)

      this.disabled = false
    },
    openSuscriptionDialog () {
      this.showSuscriptionDialog = true
      this.$nextTick(() => {
        document.getElementsByClassName('dialog__content')[0].setAttribute('style', 'z-index:602 !important')
      })
    },
    closeSuscriptionDialog () {
      this.showSuscriptionDialog = false
      this.subscribed = this.sharedWith['subscription']
    },
    suscribe () {
      this.showSuscriptionDialog = false
      if (this.subscribed) {
        Api.postV2('file/' + this.file.file_uuid + '/subscribe', {})
          .then(() => {
            this.$store.dispatch('feedback/addSnack', { text: 'Enabled', type: 'success' })
          })
          .catch((err) => {
            console.log(err)
            this.closeSuscriptionDialog()
            this.$store.dispatch('feedback/addSnack', { text: 'Something went wrong', type: 'error' })
          })
      } else {
        Api.postV2('file/' + this.file.file_uuid + '/unsubscribe', {})
          .then(() => {
            this.$store.dispatch('feedback/addSnack', { text: 'Disabled', type: 'success' })
          })
          .catch((err) => {
            console.log(err)
            this.closeSuscriptionDialog()
            this.$store.dispatch('feedback/addSnack', { text: 'Something went wrong', type: 'error' })
          })
      }
    }
  },
  computed: {
    sharedWithList () {
      return !Object.keys(this.sharedWith).length
        ? []
        : Object.keys(this.sharedWith).reduce((sharedWithCarry, sharedWithArrayKey) => {
          const parsedSharedWithArray = this.sharedWith[sharedWithArrayKey] && this.sharedWith[sharedWithArrayKey].length
            ? this.sharedWith[sharedWithArrayKey].map(sharedWithItem => ({ ...sharedWithItem, _type: sharedWithArrayKey }))
            : []
          return [...sharedWithCarry, ...parsedSharedWithArray]
        }, []).sort((currentItem, nextItem) => {
          const currentItemSortingKey = _getSortingKey(currentItem)
          const nextItemSortingKey = _getSortingKey(nextItem)

          const currentItemValue = typeof currentItem[currentItemSortingKey] === 'string' ? currentItem[currentItemSortingKey].toUpperCase() : currentItem[currentItemSortingKey]
          const nextItemValue = typeof nextItem[nextItemSortingKey] === 'string' ? nextItem[nextItemSortingKey].toUpperCase() : nextItem[nextItemSortingKey]

          return currentItemValue > nextItemValue ? 1 : -1
        })
    },
    fileID () {
      return this.file.id_file
    },
    ...mapGetters({
      smallerThan: 'viewport/smallerThan'
    }),
    selectedUsers () {
      return this.selected.map(item => item.actor_id)
    },
    accountOwner () {
      return this.file && this.file.account_owner
        ? this.file.account_owner
        : {}
    },
    currentlySharedWith () {
      const MAX_NAMES = 5
      const accounts = this.sharedWith.accounts
        ? shuffleArray(this.sharedWith.accounts)
        : []
      let extraAccounts = accounts.length - MAX_NAMES
      if (accounts.length) {
        let output = this.$tf('Shared with')
        const namedAccounts = accounts.slice(0, MAX_NAMES).map(account => {
          let toString = ''
          if (account.firstname) {
            toString += account.firstname
            if (account.lastname) {
              toString += ' ' + account.lastname
            }
          } else {
            toString += account.email
          }

          return toString
        })

        if (namedAccounts.length > 1) {
          if (accounts.length === MAX_NAMES + 1) {
            namedAccounts.pop()
            extraAccounts++
          }
          namedAccounts.forEach((account, index) => {
            if (index < namedAccounts.length - 1) {
              if (index === 0) {
                output += ' ' + account
              } else {
                output += ', ' + account
              }
            } else {
              output += ' ' + this.$tf('and') + ' ' + account
            }
          })
        } else {
          output += ' ' + namedAccounts[0]
        }

        if (accounts.length > MAX_NAMES) {
          output +=
            ' ' +
            this.$tf('and') +
            ' ' +
            this.$tf('number more accounts', { number: extraAccounts })
        }

        if (
          this.sharedWith.public_url &&
          this.sharedWith.public_url.secure_id
        ) {
          output += ' ' + this.$tf('and with Magic Link')
        }

        return output + '.'
      } else if (
        this.file !== null &&
        this.accountOwner.account_id !==
          this.$store.state.session.account.account_id
      ) {
        return this.$tf('This file is only shared to you')
      }
      if (this.sharedWith.public_url && this.sharedWith.public_url.secure_id) {
        return this.$tf('This file is shared with Magic Link')
      }
      return this.$tf("This file isn't currently shared")
    },
    isBlocked () {
      return this.shareLoading || this.unshareLoading || this.disabled
    }
  },
  watch: {
    sharedWith (val) {
      this.subscribed = val.subscription
    },
    searchInputValue: debounce(async function (value) {
      if (value !== '') {
        try {
          this.searchLoading = true
          const results = await this.searchUser(value)
          this.results = results
            .filter(
              item =>
                this.selectedUsers.indexOf(item.actor_id) === -1 &&
                this.itemID(item) !== this.accountOwner.account_uuid
            )
            .map(item => ({
              ...item,
              shareType: item.actor_id.split('/')[0]
            }))
        } catch (error) {
          if (
            error && error.status &&
            error.status === 204 &&
            this.selectedUsers.indexOf(value) === -1
          ) {
            this.$validator.validate('email', value).then(isValid => {
              if (isValid) {
                this.results = this.results.filter(
                  item => item.shareType !== 'guest'
                )
                this.results.unshift({ email: value, shareType: 'guest' })
              } else {
                this.results = []
              }
            })
          }
        } finally {
          this.searchLoading = false
        }
      }
    }, 700)
  }
}

const _getSortingKey = sortableItem => {
  const accountsSortingProperties = ['firstname', 'lastname', 'username']
  const guestsSortingProperties = ['email']
  const groupsSortingProperties = ['name']
  const organizationsSortingProperties = ['name']

  if (sortableItem._type === 'accounts') {
    return sortableItem[accountsSortingProperties[0]]
      ? accountsSortingProperties[0]
      : sortableItem[accountsSortingProperties[1]]
        ? accountsSortingProperties[1]
        : accountsSortingProperties[2]
  } else if (sortableItem._type === 'guests') {
    return guestsSortingProperties[0]
  } else if (sortableItem._type === 'groups') {
    return groupsSortingProperties[0]
  } else if (sortableItem._type === 'organizations') {
    return organizationsSortingProperties[0]
  }
}
</script>

<style lang="scss">
.share-file-panel {
  .tabs__bar {
    display: none;
  }
  .advanced-settings-btn,
  .share-btn-wrapper {
    display: block;
    margin: 0 0 0 auto;
  }

  .stop-sharing-w-everybody-btn {
    display: block;
    margin: 0 0 0 auto;
    color: #999;
    &.error {
      color: white;
    }
  }

  .share-btn-wrapper {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
  .permission-select {
    display: inline;
    max-width: 150px;
    .input-group__details {
      display: none;
    }
  }

  .share-with-container {
    background-color: #f9f9f9;
    border-radius: 3px;
    padding: 0.5rem;
    box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.2),
      inset 0 2px 2px rgba(0, 0, 0, 0.14),
      inset 0 3px 1px -2px rgba(0, 0, 0, 0.12) !important;
    .items {
      max-height: 120px;
      overflow-y: auto;
    }
  }

  .shared-with-list {
    max-height: 250px;
    overflow-y: auto;
    overflow-x: hidden;
    border-radius: 5px;

    @media screen and (max-width: 1023px) {
      max-height: 25vh;
    }

    .list__tile {
      cursor: default;
      .list__tile__action .input-group:not(.input-group--disabled),
      .list__tile__action i {
        cursor: pointer;
      }
    }
    .input-group--disabled .input-group__input,
    [disabled="disabled"] {
      opacity: 0.5;
      pointer-events: none !important;
      cursor: default !important;
    }
    .list__tile__action + .list__tile__action {
      justify-content: flex-end;
    }
  }
}

.menu__content:empty {
  box-shadow: none;
}

@media screen and (max-width: 599px) {
  .search-result,
  .shared-with-list {
    max-width: none;
    width: 100%;
    .list__tile {
      font-size: 0.95rem;
      height: 42px;
      padding: 0 8px;
      .list__tile__avatar {
        min-width: 38px;
      }
      .list__tile__sub-title {
        font-size: 0.85rem;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.title {
  font-size: 20px;
  font-weight: bold;
  margin: 1rem 0;
}
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease-out;
  overflow: hidden;
}

.collapse-enter,
.collapse-leave-to {
  max-height: 0px;
}

.collapse-enter-to,
.collapse-leave {
  .magic-link & {
    max-height: 159px;
  }

  .advanced-options & {
    max-height: 409px;
  }
}

.magic-link {
  @media screen and (max-width: 599px) {
    .share-btn-wrapper {
      margin-top: 1rem !important;
    }
  }
}

.wrapper {
  border-radius: 2px;
  height: auto;
  &,
  .switch {
    transition: all 0.3s ease-out;
    @media screen and (min-width: 1024px) {
      /deep/ .input-group__details {
        display: none;
      }
    }
  }
}

.data {
  display: inline-flex;
  flex-direction: row;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  overflow: hidden;
  font-size: 1.2rem !important;
  white-space: nowrap;
  max-width: 100%;

  @media screen and (max-width: 599px) {
    display: flex;
    position: relative;
  }

  .key {
    display: inline-block;
    padding: 0.5rem 0.8rem 0.5rem 1rem;
    background-color: rgba(0, 0, 0, 0.35);
    color: #fff;
    min-width: 5.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .value {
    display: inline-block;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
    max-width: 100%;
    width: 100%;

    .text {
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 80%;

      @media screen and (max-width: 599px) {
        max-width: 85%;
        display: block;
      }
    }

    .action {
      display: inline-block;
      margin-left: 1rem;

      @media screen and (max-width: 599px) {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: #eaeaea;
        height: calc(100% - 8px);
        margin: 4px 0 4px 3px;
        padding-right: 3px;
        width: 31px;
        text-align: center;
      }

      .btn {
        position: relative;
        width: 24px;
        height: 24px;
        vertical-align: bottom;
        margin: 0;

        @media screen and (max-width: 599px) {
          vertical-align: middle;
          margin: 3px 0 0 0;
          display: inline-block;
        }
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .checkbox-container {
    /deep/ .input-group label {
      font-size: 1em !important;
      overflow: unset !important;
      text-wrap: inherit;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/share/SharePrivate.vue